import React, { Component, createRef } from "react";
import { Modal, Row, Col, Container, Card, ProgressBar, Badge, Table, Button, Image } from 'react-bootstrap';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import gql from "graphql-tag";
import { withRouter } from "react-router-dom";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import './_studentPerformanceReport.scss';




const GETSCHEDULE_EXAMWISE_RESULTS = gql`
    query($schedule_exam_id:Int) {
        getScheduleExamWiseResults(schedule_exam_id:$schedule_exam_id){
            subject_id
            subject
            accuracy
            subject_score
            correct_qus
            correct_marks
        }
    }
`;

class ViewChapterWiseSummaryModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingPDF: false,
        };

        this.reportRef = createRef();
    }


    downloadPDF = () => {
        this.setState({ loadingPDF: true }, () => {
            setTimeout(() => {
                this.generatePDF();
            }, 100); // allow UI to render loader
        });
    };

    generatePDF = async () => {
        try {
            const element = this.reportRef.current;

            const canvas = await html2canvas(element, {
                scale: 1.5, // 🔥 reduced
                useCORS: true,
            });

            const imgData = canvas.toDataURL("image/png");

            const pdf = new jsPDF("p", "mm", "a4");

            const imgWidth = 210;
            const pageHeight = 295;

            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            const finalHeight = Math.min(imgHeight, pageHeight);

            pdf.addImage(imgData, "PNG", 0, 0, imgWidth, finalHeight);
            pdf.save("ReportCard.pdf");

        } catch (error) {
            console.error(error);
        } finally {
            this.setState({ loadingPDF: false });
        }
    };

    getAcademicYear = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth();

        if (month >= 3) {
            // April or later
            return `${year}–${String(year + 1).slice(2)}`;
        } else {
            // Jan–March
            return `${year - 1}–${String(year).slice(2)}`;
        }
    };

    render() {
        const getScheduleExamWiseResults = this.props.getScheduleExamWiseResults;
        const loading1 = getScheduleExamWiseResults.loading;
        const error1 = getScheduleExamWiseResults.error;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        let branchvalue = "";
        let classvalue = "";
        let sectionvalue = "";
        let examValue = "";

        branchvalue = this.props.globalData.globalBranches.find((a) => a.id === this.props.studentData?.branch_id);
        classvalue = this.props.globalData.classes.find((a) => a.id === this.props.studentData?.class_id);
        sectionvalue = this.props.globalData.globalSections.find((a) => a.id === this.props.studentData?.section_id);
        examValue = this.props.globalData.exams.find((a) => a.id === this.props.studentData?.exam_id);

        if (loading1) {
            return (
                <Container>
                    <div className="spinner-border text-primary text-center loading-img-center"></div>
                </Container>
            )
        }

        const subjectPerformanceGraph = {
            chart: {
                type: "column",
                backgroundColor: "#f5f7fa",
                borderRadius: 10
            },

            title: {
                text: "",
                style: {
                    fontSize: "18px",
                    fontWeight: "600"
                }
            },

            xAxis: {
                categories:
                    getScheduleExamWiseResults?.getScheduleExamWiseResults?.map(
                        s => s.subject
                    ) || [],
                title: {
                    text: "Subjects"
                },
                labels: {
                    style: {
                        fontWeight: "600"
                    }
                }
            },

            yAxis: [
                {
                    title: {
                        text: "Score / Marks"
                    }
                },
                {
                    title: {
                        text: "Accuracy (%)"
                    },
                    opposite: true,
                    max: 100
                }
            ],

            plotOptions: {
                series: {
                    borderRadius: 6,      // ✅ rounded columns
                    pointPadding: 0.15,
                    groupPadding: 0.2
                },
                column: {
                    dataLabels: {
                        enabled: true
                    }
                },
                line: {
                    dataLabels: {
                        enabled: getScheduleExamWiseResults?.getScheduleExamWiseResults?.length < 15
                    },
                    marker: {
                        enabled: true,
                        radius: 4
                    }
                }
            },

            series: [
                {
                    name: "Subject Score",
                    type: "column",
                    data:
                        getScheduleExamWiseResults?.getScheduleExamWiseResults?.map(
                            s => Number(s.subject_score || 0)
                        ) || [],
                    color: "#007bff"
                },

                {
                    name: "Correct Marks",
                    type: "column",
                    data:
                        getScheduleExamWiseResults?.getScheduleExamWiseResults?.map(
                            s => Number(s.correct_marks || 0)
                        ) || [],
                    color: "#28a745"
                },

                {
                    name: "Correct Questions",
                    type: "line",
                    data:
                        getScheduleExamWiseResults?.getScheduleExamWiseResults?.map(
                            s => Number(s.correct_qus || 0)
                        ) || [],
                    color: "#f39c12"
                },

                {
                    name: "Accuracy %",
                    type: "line",
                    yAxis: 1,
                    data:
                        getScheduleExamWiseResults?.getScheduleExamWiseResults?.map(
                            s => Number((s.accuracy * 100 || 0).toFixed(2))
                        ) || [],
                    color: "#e74c3c"
                }
            ],

            legend: {
                align: "center",
                verticalAlign: "bottom"
            },

            credits: {
                enabled: false
            },

            exporting: {
                enabled: true
            }
        };



        return (
            <Modal
                {...this.props}
                size="lg"
                scrollable
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {this.props.stateData[0]?.exam_name ?? ""}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="p-4" style={{ maxHeight: "75vh", overflowY: "auto" }}>

                    {this.props.type === "view" ? (
                        <Row>
                            <Col sm={12}>
                                {getScheduleExamWiseResults.getScheduleExamWiseResults.length > 0 ? (
                                    <HighchartsReact
                                        Highcharts={Highcharts}
                                        options={subjectPerformanceGraph}
                                    />
                                ) : (
                                    <div className="text-center text-warning">
                                        Subjects data not available
                                    </div>
                                )}
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            <Col sm={12}>
                                <div className="text-end d-flex justify-content-end mb-1">
                                    <Button onClick={this.downloadPDF} disabled={this.state.loadingPDF} size="small">
                                        {this.state.loadingPDF ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2"></span>
                                                Generating...
                                            </>
                                        ) : (
                                            <><i className="fa fa-download"></i>&nbsp;Download PDF</>
                                        )}
                                    </Button>
                                </div>
                                <div ref={this.reportRef} id="report-card">
                                    <Card className="p-3 shadow-sm">
                                        <div
                                            style={{
                                                background: "rgba(255,255,255,0.9)",
                                                padding: "20px",
                                                borderRadius: "10px",
                                            }}
                                        >

                                            {/* 🔷 Header */}
                                            <div className="report-header mb-4">

                                                {/* 🔷 Top Row: Logo + School Name */}
                                                <div className="d-flex align-items-center justify-content-between mb-2">


                                                    {/* Center: School Name */}
                                                    <div className="text-center flex-grow-1">
                                                        <h4 className="fw-bold mb-0">  <div>
                                                            {this.props.logo ? (
                                                                <Image
                                                                    src={`https://support.rizee.in/files/${this.props.logo}`}
                                                                    height="50"
                                                                    style={{ width: "auto" }}
                                                                />
                                                            ) : null}
                                                        </div>{this.props.orgname}</h4>
                                                        <small className="text-muted">
                                                            Academic Year {this.getAcademicYear()} · Class {classvalue.class}
                                                        </small>
                                                    </div>

                                                    {/* Right: Empty for balance */}
                                                    <div style={{ width: "50px" }}></div>

                                                </div>

                                                {/* 🔷 Report Title */}
                                                <div className="text-center mt-2">
                                                    <h5 className="fw-bold text-primary">
                                                        Individual Student Report Card
                                                    </h5>
                                                </div>
                                            </div>

                                            {/* 🔷 Student Section */}
                                            <Row className="align-items-center">

                                                {/* 👤 Profile Image */}
                                                <Col md={2} className="text-center mb-3 mb-md-0">
                                                    {this.props.studentData?.profile_pic ? (
                                                        <Image
                                                            src={`http://neetjeeguru.com/files/${this.props.studentData?.profile_pic}`}
                                                            width="90"
                                                            height="90"
                                                            roundedCircle
                                                            className="shadow"
                                                            alt="profile-img"
                                                        />
                                                    ) : (
                                                        <Image
                                                            src={require('../../../../images/businessman.png')}
                                                            width="90"
                                                            height="90"
                                                            roundedCircle
                                                            className="shadow"
                                                            alt="profile-img"
                                                        />
                                                    )}
                                                </Col>

                                                {/* 👤 Student Details */}
                                                <Col md={5}>
                                                    <h5 className="fw-bold mb-1">
                                                        {this.props.studentData?.student_name || "N/A"}
                                                    </h5>

                                                    <Badge bg="primary" className="mb-2">
                                                        <span className="text-success">Class</span> {classvalue.class} - <span className="text-success">Section</span> {sectionvalue.section_name}
                                                    </Badge>

                                                    <p className="mb-1">
                                                        <strong>Exam:</strong> {examValue.exam}
                                                    </p>
                                                </Col>

                                                {/* 🏫 School / Contact Info */}
                                                <Col md={5}>
                                                    <p className="mb-1">
                                                        <strong>Branch:</strong> {branchvalue?.branch_name}
                                                    </p>
                                                    <p className="mb-1">
                                                        <strong>Contact:</strong> {this.props.studentData?.contact_no}
                                                    </p>
                                                </Col>
                                            </Row>
                                        </div>

                                        <Row className="mb-3 g-3 text-center">
                                            <Col sm={12}>
                                                <div className="p-3 shadow-sm rounded bg-white">
                                                    <h5 className="fw-bold">{this.props.stateData[0]?.exam_name ?? ""}</h5>
                                                    <small className="text-muted">Exam Date: {this.props.stateData[0]?.date ?? ""}</small>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* Marks Table */}
                                        <h6 className="mb-2">Subject-wise Performance</h6>
                                        <Table className="custom-table" responsive>
                                            <thead className=" text-start">
                                                <tr>
                                                    <th>📘 Subject</th>
                                                    <th>🎯 Accuracy (%)</th>
                                                    <th>🏁 Total Score</th>
                                                    <th>✅ Correct Questions</th>
                                                    <th>💯 Marks Obtained</th>
                                                    <th>📊 Result</th>
                                                </tr>
                                            </thead>

                                            <tbody className="text-start">
                                                {
                                                    getScheduleExamWiseResults?.getScheduleExamWiseResults.length > 0 ? (
                                                        <>
                                                            {getScheduleExamWiseResults?.getScheduleExamWiseResults.map((sub, index) => {

                                                                const percentage = Math.round(sub.accuracy * 100);

                                                                // 🎯 Grade logic
                                                                let grade = "";
                                                                if (percentage >= 91) grade = "O";
                                                                else if (percentage >= 81) grade = "A1";
                                                                else if (percentage >= 71) grade = "A2";
                                                                else if (percentage >= 61) grade = "B1";
                                                                else if (percentage >= 51) grade = "B2";
                                                                else if (percentage >= 41) grade = "C";
                                                                else if (percentage >= 33) grade = "D";
                                                                else grade = "F";

                                                                return (
                                                                    <tr key={index}>
                                                                        {/* Subject */}
                                                                        <td className="fw-semibold text-start">
                                                                            <span className="d-block text-start">
                                                                                {sub.subject}
                                                                            </span>
                                                                        </td>
                                                                        {/* Max */}
                                                                        <td>{sub.subject_score}</td>

                                                                        {/* Obtained */}
                                                                        <td className="fw-bold text-primary">{sub.correct_marks}</td>

                                                                        {/* Progress */}
                                                                        <td style={{ minWidth: "150px" }}>
                                                                            <ProgressBar
                                                                                now={percentage}
                                                                                label={`${percentage}%`}
                                                                                variant={
                                                                                    percentage >= 75
                                                                                        ? "success"
                                                                                        : percentage >= 50
                                                                                            ? "warning"
                                                                                            : "danger"
                                                                                }
                                                                                animated
                                                                                striped
                                                                            />
                                                                        </td>

                                                                        {/* Grade */}
                                                                        <td>
                                                                            <Badge
                                                                                bg={
                                                                                    grade === "O" || grade === "A1"
                                                                                        ? "success"
                                                                                        : grade === "A2" || grade === "B1"
                                                                                            ? "primary"
                                                                                            : grade === "B2" || grade === "C"
                                                                                                ? "warning"
                                                                                                : "danger"
                                                                                }
                                                                                className="px-3 py-2"
                                                                            >
                                                                                {grade}
                                                                            </Badge>
                                                                        </td>

                                                                        {/* Status */}
                                                                        <td>
                                                                            <Badge
                                                                                pill
                                                                                bg={percentage >= 33 ? "success" : "danger"}
                                                                                className="px-3 py-2"
                                                                            >
                                                                                {percentage >= 33 ? "✔ Pass" : "✖ Fail"}
                                                                            </Badge>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </>
                                                    ) : (
                                                        <h4>No Data Found</h4>
                                                    )
                                                }

                                            </tbody>
                                        </Table>

                                        {/* Summary */}
                                        <h6 className="mb-2 text-start">Marks / Accuracy & Ranks</h6>
                                        <Row className="mb-3 g-3 text-center mt-3">
                                            {this.props.stateData?.map((item, index) => {

                                                const percentage = item.accuracy || 0;

                                                // 🎯 Grade logic
                                                let grade = "";
                                                if (percentage >= 91) grade = "O";
                                                else if (percentage >= 81) grade = "A1";
                                                else if (percentage >= 71) grade = "A2";
                                                else if (percentage >= 61) grade = "B1";
                                                else if (percentage >= 51) grade = "B2";
                                                else if (percentage >= 41) grade = "C";
                                                else if (percentage >= 33) grade = "D";
                                                else grade = "F";

                                                return (
                                                    <React.Fragment key={index}>

                                                        {/* Exam Name */}
                                                        {/* <Col sm={12}>
                                                            <div className="p-3 shadow-sm rounded bg-white">
                                                                <h5 className="fw-bold">{item.exam_name}</h5>
                                                                <small className="text-muted">Exam Date: {item.date}</small>
                                                            </div>
                                                        </Col> */}

                                                        {/* Total Marks */}
                                                        <Col sm={3}>
                                                            <div className="p-3 shadow-sm rounded bg-light">
                                                                <h4 className="fw-bold text-primary">{item.marks}</h4>
                                                                <small className="text-muted">Total Marks</small>
                                                            </div>
                                                        </Col>

                                                        {/* Percentage */}
                                                        <Col sm={3}>
                                                            <div className="p-3 shadow-sm rounded bg-light">
                                                                <h4 className="fw-bold text-success">{percentage}%</h4>
                                                                <small className="text-muted">Percentage</small>
                                                            </div>
                                                        </Col>

                                                        {/* Grade */}
                                                        <Col sm={3}>
                                                            <div className="p-3 shadow-sm rounded bg-light">
                                                                <h4 className="fw-bold text-warning">{grade}</h4>
                                                                <small className="text-muted">Grade</small>
                                                            </div>
                                                        </Col>

                                                        {/* Exam Rank */}
                                                        <Col sm={3}>
                                                            <div className="p-3 shadow-sm rounded bg-light">
                                                                <h4 className="fw-bold text-danger">#{item.exam_rank}</h4>
                                                                <small className="text-muted">Exam Rank</small>
                                                            </div>
                                                        </Col>

                                                        {/* Extra Rankings */}
                                                        <Col sm={3} className="mt-3">
                                                            <div className="p-3 shadow-sm rounded bg-white border">
                                                                <h6 className="fw-bold text-info">#{item.state_rank}</h6>
                                                                <small>State Rank</small>
                                                            </div>
                                                        </Col>

                                                        <Col sm={3} className="mt-3">
                                                            <div className="p-3 shadow-sm rounded bg-white border">
                                                                <h6 className="fw-bold text-info">#{item.branch_rank}</h6>
                                                                <small>Branch Rank</small>
                                                            </div>
                                                        </Col>

                                                        <Col sm={3} className="mt-3">
                                                            <div className="p-3 shadow-sm rounded bg-white border">
                                                                <h6 className="fw-bold text-info">#{item.city_rank}</h6>
                                                                <small>City Rank</small>
                                                            </div>
                                                        </Col>

                                                        <Col sm={3} className="mt-3">
                                                            <div className="p-3 shadow-sm rounded bg-white border">
                                                                <h6 className="fw-bold text-info">#{item.section_rank}</h6>
                                                                <small>Section Rank</small>
                                                            </div>
                                                        </Col>

                                                    </React.Fragment>
                                                );
                                            })}
                                        </Row>
                                        {/* Attendance */}
                                        {/* <h6>Attendance</h6>
                                        <ProgressBar now={87} label="87%" className="mb-3" /> */}

                                        {/* Remarks */}
                                        <h6>Teacher's Remarks</h6>
                                        {
                                            getScheduleExamWiseResults?.getScheduleExamWiseResults?.length > 0 ? (
                                                getScheduleExamWiseResults.getScheduleExamWiseResults.map((sub, index) => {

                                                    const percentage = Math.round(sub.accuracy * 100);

                                                    // 🎯 Grade logic
                                                    let grade = "";
                                                    if (percentage >= 91) grade = "O";
                                                    else if (percentage >= 81) grade = "A1";
                                                    else if (percentage >= 71) grade = "A2";
                                                    else if (percentage >= 61) grade = "B1";
                                                    else if (percentage >= 51) grade = "B2";
                                                    else if (percentage >= 41) grade = "C";
                                                    else if (percentage >= 33) grade = "D";
                                                    else grade = "F";

                                                    return (
                                                        <ul key={index}>
                                                            <li><strong>{sub.subject}</strong> - {percentage}% ({grade})</li>

                                                            {percentage >= 75 && <li>Excellent performance</li>}
                                                            {percentage >= 50 && percentage < 75 && <li>Good performance</li>}
                                                            {percentage < 50 && <li>Needs improvement</li>}
                                                        </ul>
                                                    );
                                                })
                                            ) : (
                                                <div className="text-center text-muted">No data available</div>
                                            )
                                        }


                                        {/* Footer */}
                                        <Row className="mt-4 text-center">
                                            <Col>
                                                <hr />
                                                <small>Class Teacher</small>
                                            </Col>
                                            {/* <Col>
                                                <Badge bg="success">PROMOTED TO CLASS XI</Badge>
                                            </Col> */}
                                            <Col>
                                                <hr />
                                                <small>Principal</small>
                                            </Col>
                                        </Row>
                                    </Card>
                                </div>
                            </Col>
                        </Row>
                    )
                    }
                </Modal.Body>
            </Modal >
        );
    }
}

export default withRouter(
    compose(
        graphql(GETSCHEDULE_EXAMWISE_RESULTS, {
            options: (props) => ({
                variables: {
                    schedule_exam_id: props.stateData?.[0]?.id
                },
                fetchPolicy: "network-only"
            }),
            name: "getScheduleExamWiseResults"
        })
    )(ViewChapterWiseSummaryModal)
);